import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { componentSizes } from '@theme/variables'

export const TableNavigationBox = styled(Box)`
  margin-top: 4px;
  margin-bottom: ${componentSizes.smDistance};

  &:first-child {
    margin: ${componentSizes.smDistance} 0 0;
  }
  &:last-child {
    margin: 0 0 ${componentSizes.smDistance};
  }
`
